export const bus = new Vue();



// WEBPACK FOOTER //
// ./themes/oprava/src/js/components/commerce/bus.js